<template>
  <div class="list-event">
    <div v-for="event in this.eventsList" :key="event.id" class="event-card">
      <MiniEvent v-if="event.post_type == 'event'" :event="event" />

      <div v-else class="separator-month mb-4" v-html="event.title" />
    </div>

    <div v-if="this.eventsList.length == 0">
      <h1>No results</h1>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";

import MiniEvent from "./MiniEvent.vue";

const { mapGetters } = Vuex;

Vue.use(Vuex);

export default {
  name: "List",
  components: {
    MiniEvent,
  },

  methods: {},

  computed: {
    ...mapGetters(["eventsList"]),
  },
};
</script>
